import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { useStyles as useStylesEcp } from './reg-step-ecp.styles';
import { useStyles } from './reg-step.styles';
import { RegStepProps } from './reg-step.models';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { InternalLinks } from '../../../../../../constants';

export const RegStep = ({
  icon, title, description, actionHref, index, actionContent, list, iconSecond, iconFirst, isEcp, isChild, indexIcon,
}: RegStepProps): JSX.Element => {
  const classes = isEcp ? useStylesEcp() : useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <>
      {icon && (
        <span
          aria-hidden="true"
          className={classes.iconWrapper}
          data-testid="step-icon-wrapper"
        >
        <img src={icon} alt="" />
      </span>
      )}
      <div className={cx(classes.content, 'content')}>
        {(index && !indexIcon) && (
          <span
            data-testid="step-icon-index"
            className={cx(classes.index)}
          >
          {index}
        </span>
        )}
        {indexIcon && (
          <img
            data-testid="step-icon-index"
            className={cx(classes.indexIcon, { 'child': isChild })}
            src={indexIcon}
            alt={`${index}`}
          />
        )}
        <h3
          data-testid="step-title"
          className={cx(classes.title, { 'child': isChild })}
        >
          {intl.formatMessage(
            { id: title },
            {
              sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              span: (chunks: ReactNode) => <span className={classes.block}>{chunks}</span>,
              a: (chunks: ReactNode) => <a className={useStyles().listEmail} href="mailto:acuvue@jnj.ru">{chunks}</a>,
            },
          )}
        </h3>
        {description && (
          <p
            data-testid="step-description"
            className={classes.description}
          >
            {intl.formatMessage(
              { id: description },
              {
                a: (chunks: ReactNode) => <a className={classes.link} href="mailto:acuvue@jnj.ru"><strong>{chunks}</strong></a>,
                sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              },
            )}
          </p>
        )}
        {list && (
          <ul
            data-testid="step-description"
            className={cx(classes.list, { 'child': isChild })}
          >
            {list.map((item, i) => (
              <li key={i} className={cx(classes.listItem, { 'child': isChild })}>
                {intl.formatMessage(
                  { id: item },
                  {
                    sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
                    imageFirst: <img className={cx(classes.image, classes.imageFirst)} src={iconFirst} alt=""/>,
                    imageSecond: <img className={classes.image} src={iconSecond} alt=""/>,
                    a: (chunks: ReactNode) => <a className={classes.link} href="mailto:acuvue@jnj.ru">{chunks}</a>,
                  },
                )}
              </li>
            ))}
          </ul>
        )}
        {actionHref && (
          <a
            data-testid="action-link"
            href={isMobile ? intl.formatMessage({ id: actionHref }) : InternalLinks.home}
            className={cx(classes.actionLink, { 'child': isChild })}
          >
          <span>
            {intl.formatMessage(
              { id: actionContent },
              { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
            )}
          </span>
          </a>
        )}
      </div>
    </>
  );
};
